Overrides for application methods.

This list accepts at most one element.
